<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <!-- <notifications></notifications> -->

    <side-bar
      :sidebar-item-color="sidebarBackground"
      :sidebar-background-image="sidebarBackgroundImage"
    >
      <!-- <mobile-menu slot="content"></mobile-menu> -->
      <sidebar-link to="/show">
        <md-icon>slideshow</md-icon>
        <p>展示頁</p>
      </sidebar-link>
      <sidebar-link to="/dashboard">
        <md-icon>dashboard</md-icon>
        <p>資訊總覽</p>
      </sidebar-link>
      <sidebar-link to="/plant_info">
        <md-icon>check_box_outline_blank</md-icon>
        <p>案場資訊</p>
      </sidebar-link>
      <sidebar-link to="/alarm">
        <md-icon>warning</md-icon>
        <p>警報</p>
      </sidebar-link>
      <sidebar-link to="/analysis">
        <md-icon>analytics</md-icon>
        <p>分析</p>
      </sidebar-link>
      <sidebar-link to="/user">
        <md-icon>person</md-icon>
        <p>使用者設定</p>
      </sidebar-link>
      <!-- <sidebar-link to="/typography">
        <md-icon>library_books</md-icon>
        <p>Typography</p>
      </sidebar-link>
      <sidebar-link to="/icons">
        <md-icon>bubble_chart</md-icon>
        <p>Icons</p>
      </sidebar-link>
      <sidebar-link to="/maps">
        <md-icon>location_on</md-icon>
        <p>Maps</p>
      </sidebar-link>
      <sidebar-link to="/notifications">
        <md-icon>notifications</md-icon>
        <p>Notifications</p>
      </sidebar-link>
      <sidebar-link to="/logout" class="sidebar-bottom">
        <md-icon>logout</md-icon>
        <p>Logout</p>
      </sidebar-link> -->
      <sidebar-link to="/logout" class="sidebar-bottom mb-4">
        <md-icon>logout</md-icon>
        <p>登出</p>
      </sidebar-link>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <!-- <fixed-plugin
        :color.sync="sidebarBackground"
        :image.sync="sidebarBackgroundImage"
      >
      </fixed-plugin> -->
      <transition name="fade">
        <dashboard-content> </dashboard-content>
      </transition>
      

      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
//import MobileMenu from "@/pages/Layout/MobileMenu.vue";
//import FixedPlugin from "./Extra/FixedPlugin.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    //MobileMenu,
    //FixedPlugin
  },
  data() {
    return {
      sidebarBackground: "orange",
      sidebarBackgroundImage: require("@/assets/img/sidebar-solar.jpg")
    };
  }
};
</script>
<style>
.fade-enter-active, 
.fade-leave-active{
    transition: opacity .5s;
}
.fade-enter, 
.fade-leave-to{
    opacity: 0;
}
</style>

